import React from "react";

import { Divider, Grid, Typography, TypographyProps } from "@mui/material";
import {
  TableCustomProps,
  applyStatusColor,
  applyStatusFontWeight,
} from "@pages/User/NewRequest/resources/table/TableCustom";
import { capitalizeFirstLetterFullString } from "@utils/index";

import { ITableHead } from "../ITableHeader";

interface ITableHeadMobile extends ITableHead {}

interface Props extends TableCustomProps {
  THead: ITableHeadMobile[];
  children?: React.ReactNode;
}

const TableMobile: React.FC<Props> = ({ children, ...props }) => {
  const TypographyTitle: React.FC<TypographyProps> = ({
    children,
    ...props
  }) => {
    return (
      <Typography
        variant={"body1"}
        sx={{ fontWeight: 700, fontSize: "1.2rem" }}
        {...props}
      >
        {children}
      </Typography>
    );
  };

  const TypographyDescription: React.FC<TypographyProps> = ({
    children,
    ...props
  }) => {
    const { sx, ...rest } = props;
    return (
      <Typography
        variant={"body1"}
        className="TypographyDescription"
        sx={{
          fontWeight: 400,
          fontSize: "1.2rem",
          lineHeight: "normal",
          ...sx,
        }}
        {...rest}
      >
        {children}
      </Typography>
    );
  };

  return (
    <Grid container className="tablemobile-container" gap={4}>
      {props.TBody.map((itemBody, indexBody) => {
        return (
          <Grid
            item
            className="TableMobile-card-produto-item"
            xs={12}
            key={indexBody}
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              gap: 1.5,
              p: 1,
            }}
          >
            {props.THead.map((itemHead, indexHead) => {
              return (
                <Grid
                  container
                  className="TableMobile-card-produto-container"
                  key={indexHead}
                  sx={{
                    border: "1px solid #fff",
                    borderRadius: 1.5,
                    background: "#fff",
                    justifyContent: "space-between",
                    p: 1,
                  }}
                >
                  <Grid item>
                    <TypographyTitle>{itemHead.label}</TypographyTitle>
                  </Grid>
                  <Grid
                    item
                    className="item-descriptiop"
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    <TypographyDescription
                      sx={{
                        color: applyStatusColor(itemBody[itemHead.key] || ""),
                        fontWeight: applyStatusFontWeight(
                          itemBody[itemHead.key] || ""
                        ),
                      }}
                    >
                      {capitalizeFirstLetterFullString(
                        itemBody[itemHead.key] || ""
                      ) ?? "-"}
                    </TypographyDescription>
                  </Grid>
                </Grid>
              );
            })}

            <Divider
              sx={{
                m: "24px 50px 0px 50px",
                border: "2px solid rgba(0,0,0,0.1)",
                borderRadius: 1,
              }}
            />
          </Grid>
        );
      })}
    </Grid>
  );
};

export default TableMobile;
